<template>
  <div
    @dragleave.prevent
    @dragover.prevent
    @drop.prevent
  >
    <Breadcrumbs
      :paths="[$route.path]"
    ></Breadcrumbs>
    <v-stepper v-model="step" vertical>
      <!--<v-chip
        :color="train_status_color"
        class="float-right mt-5 mr-5"
      >
        {{ $t("message.train.train_status") }}:&nbsp;
        <template v-if="train_status_code === 0">
          &#x25CB;({{ $t("message.common.normal") }})
        </template>
        <template v-else-if="train_status_code === 1">
          &#x25B3;({{ $t("message.common.busy") }})
        </template>
        <template v-else>
          &times;({{ $t("message.common.stop") }})
        </template>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-icon v-on="on" class="ma-2" @click="train_status_code = (train_status_code + 1) % 3">
              mdi-refresh
            </v-icon>
          </template>
          <span>{{ $t("message.common.refresh") }}</span>
        </v-tooltip>
      </v-chip>-->

      <v-stepper-step :complete="step > 1" step="1" class="pb-0">
        {{ $t("message.train.specify_parameter") }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <TrainParameter
          ref="train_parameter"
          :visible_panel="['corpus', 'title', 'command', 'lang_pair', 'field', 'detail', 'source']"
          v-on:update_trainable="trainable = $event"
          v-on:done_upload_corpus="done_upload_corpus"
          v-on:done_upload_source="done_upload_source"
        >
        </TrainParameter>

        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn
              color="primary"
              @click="execute_first()"
              :disabled="!trainable"
            >
              {{ $t("message.common.execute") }}
            </v-btn>
            <v-btn to="/">
              {{ $t("message.common.return_home") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>

      <v-stepper-step step="2" class="pt-4">
        {{ $t("message.common.start_job", { job: $t("message.train.start_" + command_type) } ) }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <Complete
          v-if="uploaded"
          :command_type="command_type"
          :jobs="job"
          :mode="mode"
          :takes_time="true">
          <template v-slot:title>
            <v-toolbar>
              <v-toolbar-title>
                {{ $t('message.complete.table_title') }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
          </template>
        </Complete>
        <Failed
          v-if="!uploaded"
          :command_type="command_type"
          :uploading_files="uploading_files" />
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import TrainParameter from '../components/TrainParameter';
import Complete from '../components/Complete';
import Failed from '../components/Failed';
import { http_error } from "../js/http_error";


export default {
  name: 'train',
  components: {
    Breadcrumbs,
    TrainParameter,
    Complete,
    Failed
  },
  mixins: [http_error],
  data: function(){
    return {
      module_id: "12",
      trainable: false,
      mode:"user",
      command_type: "train",

      // common
      step: 1,
      executing: false,

      // step2
      job: [],
      uploading_files: [],
      uploaded: true,

      // other
      train_status_code: 0,
      reserve_status_code: 0
    }
  },
  computed: {
    train_status_color: function(){
      var color = "";
      switch(this.train_status_code){
        case 0:
          color = "lime"
          break;
        case 1:
          color = "warning"
          break;
        case 2:
          color = "red"
          break;
      }
      return color;
    }
  },
  methods: {
    execute_first: function(){
      if(this.$refs.train_parameter == null){
        return;
      }
      this.executing = true;
      var train_parameter = this.$refs.train_parameter;
      if(train_parameter.source_tab === 'new_file'
        && !(train_parameter.files_valid)){
        train_parameter.$refs.upload_source.upload();
      }else if(train_parameter.source_tab === "uploaded_file"
        && train_parameter.uploaded_files
        && train_parameter.uploaded_files.length > 0){
        train_parameter.parameters.source = [];
        train_parameter.parameters.source_type = "file";
        for(var file of train_parameter.uploaded_files){
          train_parameter.parameters.source.push(file.fid);
        }
        this.execute_second();
      }else{
        // 対訳選抜なし
        this.execute_second();
      }
    },
    execute_second: function(){
      if(this.$refs.train_parameter == null){
        return;
      }
      var train_parameter = this.$refs.train_parameter;
      if(train_parameter.corpus_tab === 'new_corpus'){
        train_parameter.$refs.upload_corpus.upload();
      }else if(train_parameter.corpus_tab === 'uploaded_corpus'){
        train_parameter.parameters.corpus = [];
        train_parameter.corpus_name = [];
        train_parameter.parameters.corpus_type = "corpus";
        for(var corpus of train_parameter.uploaded_corpuses){
          train_parameter.parameters.corpus.push(corpus.cid);
          train_parameter.parameters.first_lang = corpus.lang_pair[0];
          train_parameter.parameters.second_lang = corpus.lang_pair[1];
          train_parameter.corpus_name.push(corpus.name);
        }
        this.execute_third();
      }else if(train_parameter.corpus_tab === 'translated'){
        train_parameter.parameters.corpus = [];
        train_parameter.corpus_name = [];
        train_parameter.parameters.corpus_type = "translated";
        for(var translated of train_parameter.translateds){
          train_parameter.parameters.corpus.push(translated.fid);
          //train_parameter.parameters.first_lang = corpus.lang_pair[0];
          //train_parameter.parameters.second_lang = corpus.lang_pair[1];
          train_parameter.corpus_name.push(translated.name);
        }
        this.execute_third();
      }
    },
    execute_third: function(){
      if(this.$refs.train_parameter == null){
        return;
      }
      if(!this.uploaded){
        this.step = 2;
        return;
      }
      var train_parameter = this.$refs.train_parameter;
      train_parameter.parameters.field = train_parameter.selected_field[0];
      if(train_parameter.corpus_name[0] === null){
        var corpus_title = train_parameter.parameters.corpus[0];
      }else{
        var corpus_title = train_parameter.corpus_name[0].replace(/\([A-Z]\d{5,8}\)/g, "") + "(" + train_parameter.parameters.corpus[0] + ")";
      }
      if(train_parameter.parameters.corpus.length > 1){
        corpus_title += ", ...";
      }
      if(train_parameter.parameters.title){
        train_parameter.parameters.title += ":" + corpus_title;
      }else{
        train_parameter.parameters.title = corpus_title;
      }
      train_parameter.parameters.title = train_parameter.parameters.title.substr(0, 80);
      if(train_parameter.corpus_tab === 'uploaded_file'
        || train_parameter.get_extension() !== 'xlsx'){
        delete train_parameter.parameters.first_lang;
        delete train_parameter.parameters.second_lang;
      }

      if(!train_parameter.fisher_multiplier_available){
        delete train_parameter.parameters.detail.fisher_multiplier;
      }
      if(Object.keys(train_parameter.parameters.detail).length === 0){
        delete train_parameter.parameters.detail;
      }

      this.job = [{
        "corpus": train_parameter.parameters.corpus,
        "source": train_parameter.parameters.source,
        "name": train_parameter.parameters.title,
        "jid": null,
        "status": 'uploading'
      }];
      this.$http.post(this.$store.getters.api_endpoint + "/action/train",
                      train_parameter.parameters,
                      {
                        headers: {
                          'Content-Type': 'application/json'
                        },
                      })
        .then( response => {
          this.job[0].jid = response.data.jid;
          this.job[0].status = 'complete';
          this.step = 2;
        })
        .catch(error => {
          if(this.http_error(error)){
            this.job[0].status = 'error';
            this.step = 2;
            this.$store.commit("setNotification", {
              type: "error",
              message: error.response.data
            });
          }
        });
    },
    done_upload_source: function(success){
      if(this.$refs.train_parameter == null){
        return;
      }
      var train_parameter = this.$refs.train_parameter;
      train_parameter.parameters.source = [];
      train_parameter.parameters.source_type = "file";
      for(var file of train_parameter.$refs.upload_source.uploading_files){
        train_parameter.parameters.source.push(file.fid);
        file.file_type = 'source';
      }
      this.uploaded = this.uploaded && success;
      train_parameter.$refs.upload_source.uploading_files.forEach(uploading_file => {
        this.uploading_files.push(uploading_file);
      });
      if(success){
        this.execute_second();
      }else{
        this.step = 2;
      }
    },
    done_upload_corpus: function(success){
      if(this.$refs.train_parameter == null){
        return;
      }
      var train_parameter = this.$refs.train_parameter;
      train_parameter.parameters.corpus = [];
      train_parameter.corpus_name = [];
      train_parameter.parameters.corpus_type = "file";
      for(var file of train_parameter.$refs.upload_corpus.uploading_files){
        train_parameter.parameters.corpus.push(file.fid);
        train_parameter.corpus_name.push(file.file_name);
        file.file_type = 'corpus';
      }
      this.uploaded = this.uploaded && success;
      if(!success){
        train_parameter.$refs.upload_corpus.uploading_files.forEach(uploading_file => {
          this.uploading_files.push(uploading_file);
        });
      }
      this.execute_third();
    }
  }
}
</script>
